<template>
    <BannerComponent 
        title="Nuestro Portafolio" 
        show="false" 
        paragraph="Proyectos de marketing digital que impulsan negocios" 
        colorTitle="black"
        colorParagraph="gray" 
        backgroundColor="white" 
        urlImg="" 
        urlImgDark="" 
        aligmentContent="center"
        buttonLabel="" 
        buttonBackground="" 
        buttonColor="" 
        buttonLink="" 
        paddingY="80px" 
        marginB="0" 
    />
    <PortfolioComponent />
</template>

<script>
import BannerComponent from '../components/Banner-component.vue';
import PortfolioComponent from '../components/Portfolio-component.vue';

export default {
    name: 'PortfolioPage',
    components: {
        BannerComponent,
        PortfolioComponent
    }
}
</script> 